import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
`;
Wrapper.displayName = 'Wrapper';

export const DropdownItem = styled.div`
height: 34px;
padding: 10px 17px;
display: flex;

svg {
  position: relative;
  margin-right: 15px;
}

&:hover {
  background-color: ${({ theme }) => theme.backgrounds.actionDropDownHover};
  font-weight: 600;
}
  font-size: 12px;
  font-weight: 300;
  color: ${({ theme }) => theme.text.actionDropDownItem};
`;
DropdownItem.displayName = 'DropdownItem';

export const Dropdown = styled.div`
  position: absolute;
  left: 0;
  width: 244px;
  height: 76px;
  border-radius: 3px;
  box-shadow: 2px 2px 30px 0 ${({ theme }) => theme.shadows.actionDropDown};
  border: solid 1px ${({ theme }) => theme.borders.actionDropDown};
  background-color: ${({ theme }) => theme.backgrounds.actionDropDown};
  padding: 3px 4px;
  z-index: 1000;
`;
